import {Identifiable} from "./interface/Identifiable";

export class CmrDocument implements Identifiable {
    id: number | null = null;

    constructor(
        public filename: string,
        public uploadedBy: string | null = null,
        public createdAt: Date = new Date(),
        public updatedAt: Date = new Date(),
    ) {
    }
}
